<template>
  <div class="formulario rounded-lg border border-gray-200 p-5">
      <div class="w-full md:w-1/2 px-2 mx-auto">
          <label for="nombre" class="block mb-2 text-sm font-medium text-gray-700">Nombre del evento</label>
          <input
              type="text"
              id="nombre"
              :value="evento.nombre"
              class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
              required
              @input="$emit('patch-evento', { nombre: $event.target.value })"
          />
      </div>
    <div class="flex flex-wrap -mx-2 mt-5 mb-5 ">


        <div class="w-full md:w-1/3 px-2">
        <label for="fecha_inicio" class="block mb-2 text-sm font-medium text-gray-700">Fecha de corte</label>
        <input
            type="datetime-local"
            id="fecha_inicio"
            :value="evento.fecha_inicio"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            required
            @input="$emit('patch-evento', { fecha_inicio: $event.target.value })"
        />
        </div>

        <div class="w-full md:w-1/3 px-2">
        <label for="fecha_fin" class="block mb-2 text-sm font-medium text-gray-700">Fecha de fin</label>
        <input
            type="datetime-local"
            id="fecha_fin"
            :value="evento.fecha_fin"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            required
            @input="$emit('patch-evento', { fecha_fin: $event.target.value })"
        />
        </div>
        <div class="w-full md:w-1/3 px-2">
          <label for="codigo" class="block mb-2 text-sm font-medium text-gray-700">Código (opcional)</label>
          <input
            type="text"
            id="codigo"
            :value="evento.codigo"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            @input="$emit('patch-evento', { codigo: $event.target.value })"
          />
        </div>
    </div>
    <div class="user-type-labels mt-5 mb-5">
      <div class="user-type-labels__header">
        <h3>Etiquetas de tipos de usuario</h3>
        <p>
          La etiqueta en español también se conserva en plantillas y exportaciones. La versión en inglés
          sólo se muestra al seleccionar EN; si queda vacía, se usa la etiqueta en español.
        </p>
      </div>

      <div class="user-type-labels__grid">
        <div class="user-type-label-card">
          <h4>Staff</h4>
          <label for="label_staff" class="block text-sm font-medium text-gray-700">Etiqueta en español</label>
          <input
            id="label_staff"
            type="text"
            maxlength="100"
            :value="evento.auto_staff ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="p. ej. Staff interno"
            @input="$emit('patch-evento', { auto_staff: $event.target.value })"
          />
          <label for="label_staff_en" class="block mt-3 text-sm font-medium text-gray-700">Etiqueta en inglés (opcional)</label>
          <input
            id="label_staff_en"
            type="text"
            maxlength="100"
            :value="evento.auto_staff_en ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="e.g. Internal staff"
            @input="$emit('patch-evento', { auto_staff_en: $event.target.value })"
          />
        </div>

        <div class="user-type-label-card">
          <h4>Asistentes</h4>
          <label for="label_asistente" class="block text-sm font-medium text-gray-700">Etiqueta en español</label>
          <input
            id="label_asistente"
            type="text"
            maxlength="100"
            :value="evento.auto_asistente ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="p. ej. Invitados"
            @input="$emit('patch-evento', { auto_asistente: $event.target.value })"
          />
          <label for="label_asistente_en" class="block mt-3 text-sm font-medium text-gray-700">Etiqueta en inglés (opcional)</label>
          <input
            id="label_asistente_en"
            type="text"
            maxlength="100"
            :value="evento.auto_asistente_en ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="e.g. Guests"
            @input="$emit('patch-evento', { auto_asistente_en: $event.target.value })"
          />
        </div>

        <div class="user-type-label-card">
          <h4>Expositores</h4>
          <label for="label_expositor" class="block text-sm font-medium text-gray-700">Etiqueta en español</label>
          <input
            id="label_expositor"
            type="text"
            maxlength="100"
            :value="evento.auto_expositor ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="p. ej. Conferencistas"
            @input="$emit('patch-evento', { auto_expositor: $event.target.value })"
          />
          <label for="label_expositor_en" class="block mt-3 text-sm font-medium text-gray-700">Etiqueta en inglés (opcional)</label>
          <input
            id="label_expositor_en"
            type="text"
            maxlength="100"
            :value="evento.auto_expositor_en ?? ''"
            class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="e.g. Speakers"
            @input="$emit('patch-evento', { auto_expositor_en: $event.target.value })"
          />
        </div>
      </div>
    </div>

    <hr>


    <div class="feature-card">
      <div>
        <div class="feature-title">Habilitar gestión de empresas y pagos</div>
        <div class="feature-sub">Muestra la vista previa para capturar empresas, controlar pagos y generar grupos dentro del evento.</div>
      </div>

      <button
        type="button"
        class="switch-btn"
        :class="(evento.gestion_empresas_pagos === true || evento.gestion_empresas_pagos === 1 || evento.gestion_empresas_pagos === '1') ? 'active' : ''"
        @click="$emit('patch-evento', { gestion_empresas_pagos: !(evento.gestion_empresas_pagos === true || evento.gestion_empresas_pagos === 1 || evento.gestion_empresas_pagos === '1') })"
      >
        <span></span>
      </button>
    </div>

    <div class="feature-card">
      <div>
        <div class="feature-title">Permitir carga sin límites por grupo</div>
        <div class="feature-sub">Cuando está activo, los grupos dejan de depender de cupos numéricos y pasan a manejar visibilidad por categoría con carga manual o masiva incremental.</div>
      </div>

      <button
        type="button"
        class="switch-btn"
        :class="(evento.sin_limites_carga_usuarios === true || evento.sin_limites_carga_usuarios === 1 || evento.sin_limites_carga_usuarios === '1') ? 'active' : ''"
        @click="$emit('patch-evento', { sin_limites_carga_usuarios: !(evento.sin_limites_carga_usuarios === true || evento.sin_limites_carga_usuarios === 1 || evento.sin_limites_carga_usuarios === '1') })"
      >
        <span></span>
      </button>
    </div>

    <!-- URL del Evento -->
    <div class="my-5">
      <label for="url_evento" class="block text-sm font-medium text-gray-700">URL del evento</label>
      <div class="url">
        <input type="text" class="disabled input-style url-input" disabled value="https://" />
        <input
          type="text"
          id="url_evento"
          :value="(evento.api && evento.api.url_evento) || ''"
          class="input-style"
          placeholder="Agrega solo dominio sin https"
          @input="$emit('patch-evento', { api: { url_evento: $event.target.value } })"
          @blur="$emit('sanitize-url')"
        />
        <input type="text" class="disabled input-style url-context" disabled value="/wp-j.." />
      </div>
    </div>

    <div class="col-12">
      <div class="mb-4 w-full md:w-1/2">
        <label for="usuario" class="block text-sm font-medium text-gray-700">Usuario</label>
        <input
          type="text"
          id="usuario"
          :value="(evento.api && evento.api.usuario) || ''"
          class="input-style"
          @input="$emit('patch-evento', { api: { usuario: $event.target.value } })"
        />
      </div>
      <div class="mb-4 w-full md:w-1/2">
        <label for="acceso" class="block text-sm font-medium text-gray-700">Acceso</label>
        <input
          type="text"
          id="acceso"
          :value="(evento.api && evento.api.acceso) || ''"
          class="input-style"
          @input="$emit('patch-evento', { api: { acceso: $event.target.value } })"
        />
      </div>
    </div>

    <div class="col-12">
       <div class="mb-4 w-full md:w-1/2">
        <label for="contacto_nombre" class="block text-sm font-medium text-gray-700">Nombre de contacto</label>
        <input
          type="text"
          id="contacto_nombre"
          :value="(evento.api && evento.api.contacto_nombre) || ''"
          class="input-style"
          @input="$emit('patch-evento', { api: { contacto_nombre: $event.target.value } })"
        />
      </div>
       <div class="mb-4 w-full md:w-1/2">
        <label for="contacto_telefono" class="block text-sm font-medium text-gray-700">Teléfono de contacto</label>
        <input
          type="text"
          id="contacto_telefono"
          :value="(evento.api && evento.api.contacto_telefono) || ''"
          class="input-style"
          @input="$emit('patch-evento', { api: { contacto_telefono: $event.target.value } })"
        />
      </div>
    </div>

    <div class="col-12">
       <div class="mb-4 w-full md:w-1/2">  <label for="contacto_email" class="block text-sm font-medium text-gray-700">Correo de contacto</label>
      <input
        type="text"
        id="contacto_email"
        :value="(evento.api && evento.api.contacto_email) || ''"
        class="input-style"
        @input="$emit('patch-evento', { api: { contacto_email: $event.target.value } })"
      />
    </div>
   <div class="mb-4 w-full md:w-1/2">
      <label for="asunto_mail_admin" class="block text-sm font-medium text-gray-700">Asunto personalizado invitacion admins</label>
      <input
        type="text"
        id="asunto_mail_admin"
        :value="(evento.api && evento.api.asunto_mail_admin) || ''"
        class="input-style"
        @input="$emit('patch-evento', { api: { asunto_mail_admin: $event.target.value } })"
      />
    </div>
    </div>


  </div>
</template>

<script setup lang="js">
import { defineProps } from 'vue'
defineProps({ evento: { type: Object, required: true } })
</script>

<style scoped>
.input-style { display: block; width: 100%; padding: 0.625rem; border: 1px solid #cccccc; border-radius: 0.375rem; box-shadow: inset 0 1px 1px rgba(0,0,0,0.075); }
.url { display: flex; }
.url-input { max-width: 60px; padding-left: 2px; padding-right: 2px; }
.url-context { max-width: 60px; padding-left: 4px; padding-right: 2px; }
.col-12 { display: flex; justify-content: space-between; }
.formulario {
    width: 80vw;
    max-width: 80%;
    margin: 0 auto;
}

.user-type-labels {
  border: 1px solid #dbe4ef;
  border-radius: 1rem;
  background: #f8fafc;
  padding: 1rem;
}
.user-type-labels__header h3 {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 700;
}
.user-type-labels__header p {
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.45;
  margin-top: 0.25rem;
}
.user-type-labels__grid {
  display: grid;
  gap: 0.875rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 1rem;
}
.user-type-label-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.875rem;
}
.user-type-label-card h4 {
  color: #1e293b;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

@media (max-width: 900px) {
  .user-type-labels__grid {
    grid-template-columns: 1fr;
  }
}


.feature-card {
  margin: 1.25rem auto 0;
  width: 80vw;
  max-width: 80%;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1rem 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: #f8fafc;
}
.feature-title {
  font-weight: 700;
  color: #0f172a;
}
.feature-sub {
  color: #64748b;
  font-size: 0.92rem;
  margin-top: 0.25rem;
}
.switch-btn {
  min-width: 54px;
  height: 30px;
  border-radius: 999px;
  background: #cbd5e1;
  position: relative;
  transition: background 0.2s ease;
}
.switch-btn span {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #fff;
  transition: transform 0.2s ease;
}
.switch-btn.active {
  background: #22c55e;
}
.switch-btn.active span {
  transform: translateX(24px);
}

</style>
